/**
 * DIEUKYDIEU.TV - TOPIC QUIZ API SERVICE
 * Connects UI to backend quiz questions & answer recording endpoints with mock fallback.
 * Under 300 lines rule compliant.
 */

import { API_CONFIG } from './config.js';
import { apiClient } from './client.js';
import { mockAdapter } from './mock/mock-adapter.js';

export const quizApi = {
    /**
     * Get quiz question & options for a given topic
     * @param {string} topicId 
     * @param {string} lang 
     */
    async getTopicQuiz(topicId, lang = 'vi') {
        if (API_CONFIG.USE_MOCK) {
            return (await mockAdapter.getTopicQuiz(topicId, lang)).data;
        }

        try {
            const res = await apiClient.get(`/quiz/topics/${encodeURIComponent(topicId)}`, { lang });
            return res.data || res;
        } catch (err) {
            console.warn(`[quizApi] Failed fetching quiz topic ${topicId}, falling back to mock:`, err.message);
            if (API_CONFIG.ENABLE_FALLBACK_ON_ERROR) {
                return (await mockAdapter.getTopicQuiz(topicId, lang)).data;
            }
            throw err;
        }
    },

    /**
     * Submit user's quiz choice for analytics / personalization
     * @param {string} topicId 
     * @param {number|string} chosenOption 
     */
    async submitQuizAnswer(topicId, chosenOption) {
        if (API_CONFIG.USE_MOCK) {
            return { success: true, topicId, chosenOption };
        }

        try {
            return await apiClient.post('/quiz/submit', { topicId, chosenOption });
        } catch (err) {
            console.warn('[quizApi] Failed submitting quiz answer to server:', err.message);
            return { success: false, error: err.message };
        }
    }
};
